export const GuidRegex =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export const getRegexForEnum = (e: { [x: string]: string }) =>
  `(${Object.values(e).join('|')})`;
